<template>
  <el-dialog
    class="dialog-wrapper family-category-dialog"
    visible
    width="480px"
    :show-close="false"
    @close="$emit('close')"
    @opened="focusFirstField"
  >
    <ContentHeader
      slot="title"
      :title="
        isRename
          ? $t('familyCategories.dialog.renameTitle')
          : $t('familyCategories.dialog.createTitle')
      "
    />
    <el-form
      label-position="top"
      @submit.native.prevent="submit"
    >
      <el-form-item :label="$t('familyCategories.dialog.italian')">
        <el-input
          ref="firstField"
          v-model="names.it"
          maxlength="64"
        />
      </el-form-item>
      <el-form-item
        :label="$t('familyCategories.dialog.english')"
        :error="englishError"
      >
        <el-input
          v-model="names.en"
          maxlength="64"
          @input="englishError = ''"
        />
      </el-form-item>
      <el-form-item :label="$t('familyCategories.dialog.spanish')">
        <el-input
          v-model="names.es"
          maxlength="64"
          :placeholder="$t('familyCategories.dialog.spanishPlaceholder')"
        />
      </el-form-item>

      <FormButtons>
        <el-button
          type="secondary"
          @click.prevent="$emit('close')"
        >
          {{ $t('familyCategories.cancel') }}
        </el-button>
        <el-button
          type="primary"
          native-type="submit"
          :disabled="!canSubmit"
          :loading="saving"
        >
          {{
            isRename
              ? $t('familyCategories.dialog.save')
              : $t('familyCategories.dialog.create')
          }}
        </el-button>
      </FormButtons>
    </el-form>
  </el-dialog>
</template>

<script>
  import { analysesApi } from '@/api';
  import ContentHeader from '@/components/ContentHeader.vue';
  import FormButtons from '@/components/FormButtons.vue';

  const translation = (category, langCode) => {
    const found = (category.translations || []).find(
      (item) => item.langCode === langCode
    );
    return found ? found.label : '';
  };

  export default {
    name: 'FamilyCategoryDialog',
    components: {
      ContentHeader,
      FormButtons,
    },
    props: {
      // The category to rename; none to create a new one
      category: { type: Object, default: null },
    },
    data() {
      const { category } = this;
      return {
        names: {
          it: category ? translation(category, 'it') : '',
          en: category ? category.label : '',
          es: category ? translation(category, 'es') : '',
        },
        englishError: '',
        saving: false,
      };
    },
    computed: {
      isRename() {
        return !!this.category;
      },
      canSubmit() {
        return !!(this.names.it.trim() && this.names.en.trim()) && !this.saving;
      },
    },
    methods: {
      focusFirstField() {
        this.$refs.firstField.focus();
      },
      async submit() {
        if (!this.canSubmit) return;
        const data = {
          label: this.names.en.trim(),
          translations: ['it', 'es']
            .map((langCode) => ({
              langCode,
              label: this.names[langCode].trim(),
            }))
            .filter((item) => item.label),
        };
        this.saving = true;
        try {
          if (this.isRename) {
            await analysesApi.familyCategoriesPatch(this.category.code, data);
          } else {
            await analysesApi.familyCategoriesCreate(data);
          }
          this.$emit('saved', this.names.it.trim());
        } catch (error) {
          const { status } = error.response;
          if (status === 409) {
            this.englishError = this.$t('familyCategories.dialog.duplicate');
          } else if (status === 422) {
            this.englishError = error.response.data.error.message;
          } else {
            this.$notify({
              showClose: true,
              type: 'error',
              message: error.response.data.error.message,
            });
          }
        } finally {
          this.saving = false;
        }
      },
    },
  };
</script>
